import React from "react";
import style from "../../../styles/windowsScreenStyle/resultSection.module.css";
import { useSelector } from "react-redux";

export default function ResultsSection() {
  const daynight = useSelector((state) => state.data.dayNight);
  return (
    <section
      class={`${style.resultSection} ${daynight ? style.nightMode : ""}`}
    >
      <div class="container">
        <div class="row">
          <div class="col-lg-6">
            <div class={style.resultImageSide}>
              {/*
              <img
                class={style.blackDotsImage}
                src="/images/black-dots-img.svg"
                alt=""
              />
              */}
              <div class={style.squareBox}></div>
              <img
                class={`img-fluid ${style.mainImg}`}
                src="/demo/features/butterfly.png"
              />
            </div>
          </div>
          <div class="col-lg-6 mt-5 pt-0 pl-3 pt-lg-4 pl-lg-5">
            <h2 class="subHeading mb-2">Stunning Results</h2>
            <div class="commonText">
              Get Artificial Intelligence powered cut-outs - whether you edit
              product photos or portrait shots. Even challenging edges, like
              hair, and other tricky conditions are handled exceptionally well.
            </div>
            <a class="commonLink mt-4" href="#">
              See for yourself<i class="fas fa-chevron-right"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
